import api from '@/config/api'
import type { ApiResponse } from '@/shared/types/api'
import type { EmploiDuTempsDto, CreateEmploiDuTempsRequest } from '@/shared/types/emploi-du-temps'

export const emploiDuTempsApi = {
  getByEtudiantId: (etudiantId: number) =>
    api
      .get<ApiResponse<EmploiDuTempsDto[]>>(`/api/emploi-du-temps/etudiant/${etudiantId}`)
      .then((r) => r.data.data),

  getById: (id: number) =>
    api
      .get<ApiResponse<EmploiDuTempsDto>>(`/api/emploi-du-temps/${id}`)
      .then((r) => r.data.data),

  create: (data: CreateEmploiDuTempsRequest) =>
    api
      .post<ApiResponse<EmploiDuTempsDto>>('/api/emploi-du-temps', data)
      .then((r) => r.data.data),

  update: (id: number, data: CreateEmploiDuTempsRequest) =>
    api
      .put<ApiResponse<EmploiDuTempsDto>>(`/api/emploi-du-temps/${id}`, data)
      .then((r) => r.data.data),

  delete: (id: number) => api.delete(`/api/emploi-du-temps/${id}`),
}
